/** 降级类型 */
export enum DegradedType {
  /** 主动降级。创建插件时，当dmV2config.isDegraded: true时 */
  INITIATIVE = 'INITIATIVE',
  /** 之前被降级过。目前仅有“因为低帧率降级”会保存在localStorage中，下次进入时直接降级 */
  DEGRADED_BEFORE = 'DEGRADED_BEFORE',
  /** CPU核数低于阈值 */
  CPU_CORE_NUM_LOW = 'CPU_CORE_NUM_LOW',
  /** 不支持webgl、未开启硬件加速 */
  NO_WEBGL = 'NO_WEBGL',
  /** 弹幕低帧率，一分钟平均帧率小于阈值（20）时会降级 */
  LOW_FPS = 'LOW_FPS',
  /** video 掉帧 */
  VIDEO_FRAME_DROP = 'VIDEO_FRAME_DROP',
  /** frame 加载失败 */
  FRAME_LOAD_FAILED = 'FRAME_LOAD_FAILED',
  /** frame 加载失败 */
  FRAME_LOAD_OVERTIME = 'FRAME_LOAD_OVERTIME',
  /** frame 失去心跳检测  */
  FRAME_LOST_HEART_BEAT = 'FRAME_LOST_HEART_BEAT',
  /** CC引擎加载失败 */
  CC_LOAD_FAILED = 'CC_LOAD_FAILED',
  /** CC引擎加载超时 */
  CC_LOAD_OVERTIME = 'CC_LOAD_OVERTIME',
  /** 其他原因，eg safari、pad、浏览器版本较低  */
  OTHER = 'OTHER',
  /** webgl 上下文丢失 */
  WEBGL_CONTEXT_LOST = 'WEBGL_CONTEXT_LOST',
}

/** 下列降级原因（eg、性能较低、环境不支持），不能再次切换为cocos，只能运行css版本。 */
export const DEGRADED_FORCE_LIST = [
  DegradedType.INITIATIVE,
  DegradedType.CPU_CORE_NUM_LOW,
  DegradedType.NO_WEBGL,
  DegradedType.OTHER,
];
